import {useSearchParams} from 'next/navigation';
import {useEffect, useRef} from 'react';

import CenteredButton from '@/components/CenteredButton';
import {analytics} from '@/lib/analytics';
import {AuthProvider, AuthProviderIcons} from '@/utils/AuthProvider';

const labels: Record<AuthProvider, string> = {
  google: 'Continue with Google',
  github: 'Continue with GitHub',
  sso: 'Continue with SSO',
};

interface Props {
  provider: AuthProvider;
  path?: string;
}

export default function SignInWithProvider({provider, path}: Props) {
  const searchParams = useSearchParams();
  const next = searchParams.get('next');
  const publicID = searchParams.get('organization_public_id');
  const iframeOrigin = searchParams.get('iframe_origin');
  const formRef = useRef<HTMLFormElement>(null);

  // Set up a listener for submit events on the form. The form uses a GET request
  // to direct the user to the correct destination.
  useEffect(() => {
    if (analytics && formRef.current) {
      analytics.trackSubmit(formRef.current, 'signIn', {provider});
    }
  }, [provider]);

  return (
    <form
      method="GET"
      action={path ? path : `/auth/${provider}/login`}
      ref={formRef}
      data-testid={`${provider}-signin-form`}
      style={{display: 'flex', flexDirection: 'column'}}
    >
      {next ? <input type="hidden" name="next" value={next} /> : null}
      {publicID ? <input type="hidden" name="organization_public_id" value={publicID} /> : null}
      {iframeOrigin ? <input type="hidden" name="iframe_origin" value={iframeOrigin} /> : null}
      <CenteredButton
        id={`signin-${provider}`}
        icon={AuthProviderIcons[provider]}
        label={labels[provider]}
        style={{width: '100%'}}
      />
    </form>
  );
}
